import React, { useState, useEffect } from "react"
import withStyles from "react-jss"
import {
  RESULTS_FADEIN,
  RESULTS_FADEOUT,
  SECTION_DURATION,
} from "../data/globalStyles"
import { RESULTS_RENDER_DATA, RESULT_IDS } from "../data/uniqueValues"
import { results } from "../data/results"
import { articles } from "../data/articles"
import useWindowSize from "../hooks/useWindowSize"

const styles = {
  mainContainer: {
    marginTop: "70px",
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    margin: "2rem 10% 0 0",
    padding: "3rem",
    width: "80%",
    textAlign: "center",
    "@media only screen and (max-width: 480px)": {
      marginTop: "1rem",
      alignItems: "center",
      width: "100%",
      margin: "2rem 0 0 2rem",
    },
    "@media only screen and (max-width: 795px)": {
      flexDirection: "column",
      width: "95%",
      padding: "3rem 0 0 0",
      margin: "2rem 5% 0 0",
    },
    animation: ({ show }) =>
      `${
        show ? `$${RESULTS_FADEIN}` : `$${RESULTS_FADEOUT}`
      } ${SECTION_DURATION} ease-in-out`,
  },
  [`@keyframes ${RESULTS_FADEIN}`]: {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  [`@keyframes ${RESULTS_FADEOUT}`]: {
    from: {
      opacity: 1,
    },
    to: {
      opacity: 0,
    },
  },
  heading: {
    color: "#E4503B",
    fontFamily: "Futura",
    fontWeight: "400",
    padding: "0 0.5rem",
    textAlign: "center",
    fontSize: "22px",
    lineHeight: 1.4,
    marginBottom: "1.6em",
  },
  result: {
    color: "#000000",
    fontFamily: "SourceSerifPro",
    fontWeight: "700",
    padding: "0 1rem",
    textAlign: "center",
    fontSize: "33px",
    lineHeight: 1.4,
    marginBottom: "1.6em",
    "@media only screen and (max-width: 525px)": {
      padding: 0,
    },
  },
  price: {
    fontFamily: "Futura",
    padding: "20px 0",
    textAlign: "center",
    fontSize: "16px",
    lineHeight: 1.4,
    marginBottom: "4.6em",
    textTransform: "uppercase",
    border: "1px solid #000000",
    boxSizing: "border-box",
    background: "#000000",
    color: "#ffffff",
    cursor: "pointer",
    margin: "0 30%",
    "@media only screen and (max-width: 1200px)": {
      margin: "20px 20%",
    },
    "@media only screen and (max-width: 1184px)": {
      margin: "20px 5%",
    },
  },

  startOver: {
    display: "flex",
    flexDirection: "row",
    color: "#000000",
    fontFamily: "Futura",
    fontWeight: "400",
    //padding: "0 2rem",
    textAlign: "center",
    fontSize: "14px",
    lineHeight: 1.4,
    alignItems: "center",
    justifyContent: "center",
  },
  quiz: {
    color: "#E4503B",
    borderBottom: "1px solid #E4503B",
    cursor: "pointer",
    marginLeft: "3px",
  },
  articleImage: {
    width: "260px",
    height: "146.25px",
    margin: "0 2% 0 5%",
    "@media only screen and (max-width: 690px)": {
      width: "300px",
      height: "168.75px",
      margin: "0 2%",
    },
  },
  image: {
    width: "400px",
    height: "400px",
    //margin: "0 5rem",
    "@media only screen and (max-width: 920px) and (min-width: 796px)": {
      width: "250px",
      height: "250px",
      marginLeft: "5%",
    },
    "@media only screen and (max-width: 795px)": {
      width: "300px",
      height: "300px",
      margin: "2rem 0",
    },
    "@media only screen and (max-width: 1300px) and (min-width: 921px)": {
      marginLeft: "5%",
    },
  },
  productDetails: {
    //width: "80%",
    margin: "0 1rem 0 2rem",
  },
  // details: {
  //   textAlign: "center",
  //   justifyContent: "center",
  //   alignItems: "center",
  // },
  description: {
    color: "#000000",
    fontFamily: "SourceSerifPro",
    fontWeight: "500",
    padding: "0 20%",
    fontSize: "calc(16px + (18 - 14) * ((100vw - 300px) / (1600 - 300)))",
    lineHeight: 1.4,
    marginBottom: "2.6em",
    textTransform: "none",
    "@media only screen and (max-width: 1200px)": {
      padding: "0 10px",
      margin: "20px 0 20px 0",
    },
  },
  articlesContainer: {
    display: "flex",
    flexDirection: "column",
    margin: "2rem auto",
  },
  article: {
    display: "flex",
    flexDirection: "row",
    textDecoration: "none",
    margin: "1rem 2rem",
    cursor: "pointer",
    "@media only screen and (max-width: 690px)": {
      flexDirection: "column",
    },
  },
  articleDetail: {
    display: "flex",
    flexDirection: "column",
    color: "#000000",
    fontFamily: "SourceSerifPro",
    fontSize: "20px",
    lineHeight: 1.4,
    fontWeight: "bold",
    textAlign: "left",
    "@media only screen and (max-width: 690px)": {
      width: "300px",
      margin: "0 2%",
    },
  },
  articleHeader: {
    color: "#E4503B",
    fontSize: "12px",
    lineHeight: 1.4,
    letterSpacing: "1px",
    fontWeight: 500,
    margin: "1rem 0",
  },
}

const Results = ({
  classes,
  setShow,
  section,
  ids,
  onAnimationEnd,
  setResetQuiz,
}) => {
  const [renderData, setRenderData] = useState(RESULTS_RENDER_DATA)
  //const [url, setUrl] = useState("https://")

  let widthWindow = useWindowSize().width

  useEffect(() => {
    if (ids.length === 1) {
      // query params having ids that don't belong in results break the app
      // filtering out stray ids
      const goodIds = ids.filter((d) => d !== 0 && RESULT_IDS.includes(d))

      const allResults = goodIds.map((id) =>
        results.find((d) => d.resultId === id)
      )

      if (allResults && allResults.length === 1) setRenderData(allResults)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids])
  // console.log(renderData)
  const restartQuiz = () => {
    // If URL contains query params for the results,
    // load the base URL without query params to start
    // the quiz from scratch
    // reset all previous calculations
    setShow((d) => ({
      ...d,
      intro: true,
      results: false,
    }))
    setTimeout(() => {
      setRenderData(RESULTS_RENDER_DATA)
      setResetQuiz(true)
    }, 1000)

    if (window.parent && window.parent.dataLayer) {
      window.parent.dataLayer.push({
        event: "datavisualization-HolidayGiftGuide-restart",
      })
    }
  }

  const openLink = (item, link) => {
    window.open(link, "_blank")
    if (window.parent && window.parent.dataLayer) {
      window.parent.dataLayer.push({
        event: "datavisualization-HolidayGiftGuide-buyButton",
        "gtm.elementUrl": link,
        eventLabel: item,
      })
    }
  }

  const articlesBasedonCategory =
    renderData.length === 1 && renderData[0].Category
      ? articles
          .map((article, i) => {
            if (
              renderData[0].Category.toLowerCase().includes(
                article.category.toLowerCase()
              )
            )
              return article
            else return null
          })
          .filter((article) => article !== null)
          .filter((v, i, a) => a.findIndex((t) => t.title === v.title) === i)
      : null

  return section === "results" ? (
    widthWindow >= 796 ? (
      <footer className={classes.mainContainer} onAnimationEnd={onAnimationEnd}>
        <div className={classes.container}>
          <div className={classes.details}>
            <div className={classes.heading}>{`Your perfect gift is:`}</div>
            <div className={classes.result}>{renderData[0].Result}</div>
            <div className={classes.description}>
              {renderData[0].Description}
            </div>
            <div
              className={classes.price}
              onClick={() =>
                openLink(renderData[0].Result, renderData[0].Link)
              }>{`${renderData[0].Price} at ${renderData[0].Retailer}`}</div>
            <div className={classes.startOver}>
              <div>{"Still shopping?"} </div>
              <span className={classes.quiz} onClick={restartQuiz}>
                {" Take the quiz again"}
              </span>
            </div>
          </div>
          <img
            className={classes.image}
            src={renderData[0].ImageURL}
            alt={renderData[0].Result}></img>{" "}
        </div>
        {articlesBasedonCategory && articlesBasedonCategory.length > 0 ? (
          <div className={classes.articlesContainer}>
            {articlesBasedonCategory.map((article, i) => {
              return (
                <div
                  key={i}
                  className={classes.article}
                  onClick={() => openLink(article.title, article.URL)}>
                  <img
                    className={classes.articleImage}
                    src={article.imgURL}
                    alt={article.title}></img>
                  <div className={classes.articleDetail}>
                    <div className={classes.articleHeader}>{"ARTICLE"}</div>
                    <div>{article.title}</div>
                  </div>
                </div>
              )
            })}
          </div>
        ) : null}
      </footer>
    ) : (
      <footer className={classes.mainContainer} onAnimationEnd={onAnimationEnd}>
        <div className={classes.container}>
          <div className={classes.productDetails}>
            <div className={classes.heading}>{`Your perfect gift is:`}</div>
            <img
              className={classes.image}
              src={renderData[0].ImageURL}
              alt={renderData[0].Result}></img>
            <div className={classes.result}>
              {renderData[0].Result}
              <div className={classes.description}>
                {renderData[0].Description}
              </div>
            </div>
            <div
              className={classes.price}
              onClick={() =>
                openLink(renderData[0].Result, renderData[0].Link)
              }>{`${renderData[0].Price} at ${renderData[0].Retailer}`}</div>
            <div className={classes.startOver}>
              <div>{"Still shopping? "}</div>
              <div className={classes.quiz} onClick={restartQuiz}>
                {" Take the quiz again"}
              </div>
            </div>
          </div>
          {articlesBasedonCategory && articlesBasedonCategory.length > 0 ? (
            <div className={classes.articlesContainer}>
              {articlesBasedonCategory.map((article, i) => {
                return (
                  <div
                    key={i}
                    className={classes.article}
                    onClick={() => window.open(article.URL)}>
                    <img
                      className={classes.articleImage}
                      src={article.imgURL}
                      alt={article.title}></img>
                    <div className={classes.articleDetail}>
                      <div className={classes.articleHeader}>{"ARTICLE"}</div>
                      <div>{article.title}</div>
                    </div>
                  </div>
                )
              })}
            </div>
          ) : null}
        </div>
      </footer>
    )
  ) : null
}

export default withStyles(styles)(Results)
